/** Title-case each word: "maria arenas" → "Maria Arenas". */
export const toTitleCase = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(
      /[^\s-]+/gu,
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
